import React from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";

interface IProps {
    className?: string;
    onClick: () => void;
    size?: string;
    top?: number;
    right?: number;
}

export const CloseIconButton = (props: IProps) => {
    const {top = 3, right = 3} = props;

    const wrapperStyles = css({
        position: "absolute",
        top: top,
        right: right,
        cursor: "pointer"
    });

    return (
        <div className={cx(wrapperStyles, props.className)}>
            <CloseIcon onClick={props.onClick} size={props.size || "2.4"} />
        </div>
    );
};
import React from "react";
import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";

interface IProps {
    className?: string;
    onClick: () => void;
    size?: string;
    top?: number;
    right?: number;
}

export const CloseIconButton = (props: IProps) => {
    const {top = 3, right = 3} = props;

    const wrapperStyles = css({
        position: "absolute",
        top: top,
        right: right,
        cursor: "pointer"
    });

    return (
        <div className={cx(wrapperStyles, props.className)}>
            <CloseIcon onClick={props.onClick} size={props.size || "2.4"} />
        </div>
    );
};
